import { render, staticRenderFns } from "./sortEn.vue?vue&type=template&id=c657a8fe&scoped=true"
import script from "./sortEn.vue?vue&type=script&lang=js"
export * from "./sortEn.vue?vue&type=script&lang=js"
import style0 from "./sortEn.vue?vue&type=style&index=0&id=c657a8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c657a8fe",
  null
  
)

export default component.exports